import MainPage from './components/MainDirectory/MainPage'
import AllStatementsPage from './components/StatementDirectory/AllStatementsPage'
import BookExchangeTabsComponent from './components/ExchangeDirectory/BookExchangeTabsComponent'
import SummaryStatementComponent from './components/StatementDirectory/SummaryStatementComponent'
import TermConditionsComponent from './components/CreateNewStatement/TermConditionsComponent'
import StatementBookTabsComponent from './components/CreateNewStatement/StatementBookTabsComponent'
import RedeemPointsComponent from './components/CreateNewStatement/RedeemPointsComponent'
import StatementBookListReceipt from './components/StatementDirectory/StatementBookListReceipt'
import testComponent from "./components/TestComponents/testComponent";
import ContactUs from "./components/ContactUs";
import FinalSubmitComponent from "./components/StatementDirectory/FinalSubmitCheckedComponent";
import FaqComponent from "./components/FaqComponent";
import Tickets from "./components/issues/issues";

export const routes = [
    { path: '', component:  MainPage},
    { path: '/statements', component:  AllStatementsPage},
    { path: '/bookExchange', component: BookExchangeTabsComponent},
    { path: '/statementBookList', component:  SummaryStatementComponent},
    { path: '/statementBookListReceipt', component: StatementBookListReceipt},
    { path: '/termConditions', component:  TermConditionsComponent},
    { path: '/newStudentBookList', component: StatementBookTabsComponent},
    { path: '/redeemPoints', component: RedeemPointsComponent},
    { path: '/contactUs', component: ContactUs},
    { path: '/finalSubmit', component: FinalSubmitComponent},
    { path: '/test' , component: testComponent},
    { path: '/faq' , component: FaqComponent},
    { path: '/tickets' , component: Tickets}
];
